import {redirect} from 'react-router-dom';
import {store as AppStore} from '../store/store';
import {storeAppointmentData} from './partials/store_appointment_data.ts';
import {handleErrors, handleSuccess} from '../support/handle_errors_success.ts';

export async function postAppointmentAction(store: typeof AppStore, request: Request) {
    if (request.method !== 'POST') {
        throw new Response('', {status: 405});
    }

    const formData = await request.formData();
    try {
        await storeAppointmentData(store, formData);
        handleSuccess();
        return redirect('/appointment/success');
    } catch (errors) {
        console.error(errors);
        handleErrors(errors);
    }

    return redirect(request.url);
}
